const dni = {
    "54": "DNI",  // Argentina
    "591": "CI",  // Bolivia
    "55": "RG",  // Brasil
    "56": "RUT",  // Chile
    "57": "CI",  // Colombia
    "506": "CI",  // Costa Rica
    "53": "CI",  // Cuba
    "593": "CI",  // Ecuador
    "503": "DUI",  // El Salvador
    "502": "DPI",  // Guatemala
    "504": "CI",  // Honduras
    "52": "INE",  // México
    "505": "CI",  // Nicaragua
    "507": "CI",  // Panamá
    "595": "CI",  // Paraguay
    "51": "DNI",  // Perú
    "1": "CI",  // República Dominicana (mismo que Estados Unidos)
    "598": "CI",  // Uruguay
    "58": "CI"  // Venezuela
};
const validarCodigoDni = (phone)=>{
    const tres = phone ? phone.substring(1, 4):'S/D';
    const dos = tres.slice(0, -1)
    const uno = dos.slice(0, -1)
  
    var currency = ''
    if(dni[tres]){
    currency = dni[tres]
    }else if (dni[dos]){
    currency = dni[dos]
    }else if (currency= dni[uno])
    {
        currency= dni[uno]
    }else{
      currency='CI'
    }
    return currency
}
export {dni, validarCodigoDni};